/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./json-ld.component";
import * as i2 from "@angular/platform-browser";
var styles_JsonLdComponent = [];
var RenderType_JsonLdComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_JsonLdComponent, data: {} });
export { RenderType_JsonLdComponent as RenderType_JsonLdComponent };
export function View_JsonLdComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_JsonLdComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-json-ld", [], [[8, "innerHTML", 1]], null, null, View_JsonLdComponent_0, RenderType_JsonLdComponent)), i0.ɵdid(1, 573440, null, 0, i1.JsonLdComponent, [i2.DomSanitizer], null, null)], null, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1).jsonLD; _ck(_v, 0, 0, currVal_0); }); }
var JsonLdComponentNgFactory = i0.ɵccf("app-json-ld", i1.JsonLdComponent, View_JsonLdComponent_Host_0, { json: "json" }, {}, []);
export { JsonLdComponentNgFactory as JsonLdComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/common-theme/seo/json-ld.component.ngfactory.js.pre-build-optimizer.js